import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useSelector } from "react-redux";
import { api } from "../utils/hostname";
import url from "../url";
import * as userSelectors from "../redux/user/selectors";

type RequestLoyaltyMascotsParams = {
  loyaltyId: string;
  currency: string;
};

export type ResponseLoyaltyMascotInner = {
  id: string;
  name: string;
  link: string;
};

type ResponseLoyaltyMascots = {
  data: ResponseLoyaltyMascotInner[];
};

const requestLoyaltyMascots = (params: RequestLoyaltyMascotsParams) =>
  api(true, true).get<ResponseLoyaltyMascots>(
    url.config.api.loyalty.loyaltyMascots,
    { params },
  );

type UseGetMascotsUserParams = {
  loyaltyId: string;
  currency: string;
};

// Все маскоты на программу лояльности
export const useGetMascotsLoyalty = (params: UseGetMascotsUserParams) => {
  const userId = useSelector(userSelectors.id) || "";
  return useQuery<AxiosResponse<ResponseLoyaltyMascots>>({
    queryKey: ["user mascots", userId],
    queryFn: () => requestLoyaltyMascots(params),
    enabled: !!userId && !!params.loyaltyId && !!params.currency,
    staleTime: 5 * 60 * 1000,
  });
};
